import { API_URL, apiAssetUrl } from '../services/apiClient';

/** Keep uploaded photos API-relative while preserving existing HTTPS directory photos. */
export function avatarImageUrl(source: string | null | undefined): string | undefined {
  const value = source?.trim();
  if (!value || /[\u0000-\u001f\u007f]/.test(value)) return undefined;
  if (/^\/files\/avatars\/[a-z0-9_-]+\.(?:jpe?g|png|webp|gif)$/i.test(value)) {
    return apiAssetUrl(value) ?? undefined;
  }
  if (!/^https?:\/\//i.test(value)) return undefined;
  try {
    const url = new URL(value);
    if (url.username || url.password) return undefined;
    if (url.protocol === 'https:') return value;
    // HTTP is only for an explicitly configured development API, never an
    // arbitrary external source or the native application's WebView origin.
    if (API_URL && url.origin === new URL(API_URL).origin) return value;
  } catch {
    return undefined;
  }
  return undefined;
}
